import { RenderTiles } from '../../components/common';
import ChildHeader from '../../components/ui/ChildHeader';
import {subTiles} from './SubTiles';

const PDCSection = () => {
  return (
    <>
      <ChildHeader text="PDC Section" />
      <RenderTiles tilesObj={subTiles} height="100vh" justify="start" />
    </>
  );
};

export default PDCSection;
